<template>
  <div class="account">
    <!-- 佣金 积分 -->
      <div class="my-asset">
        <div class="my-brokerage">
          <div @click="$router.push('/brokerage')">
            <p class="p1">
              我的佣金
            </p>
            <p class="p2">
              {{yongJ}}
            </p>
          </div>
          <p class="xiangqing" @click="$router.push('binding-iphone')">
            绑定手机号
          </p>
        </div>
        <div class="color">
        </div>
        <div class="my-integral" @click="$router.push('/pay-record')">
          <p class="p1">
            我的账户
          </p>
          <p class="p2">
            {{zhangH}}
          </p>
          <p class="xiangqing">
            <a style="color:#333" data-miniprogram-appid="wxeab07b9c9e37c0e9" data-miniprogram-path="pages/index/index" href="http://www.qq.com">进入商城</a>
          </p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      yongJ: '', //  佣金
      zhangH: '' , // 账户
    }
  },
  created(){
    // 余额 佣金
    this.$axios.get('http://members.kfm666666.net/api/dcash/index/balance').then(res => {
      // console.log(res)
      this.yongJ = res.data.data.brokerage
      this.zhangH = res.data.data.balance
    })
  }
}
</script>
<style lang="less" scoped>
  // 佣金 积分
  .my-asset{
    width: 100%;
    height: 2.8rem;
    display: flex;
    border-bottom: .2rem #F4F4F4 solid;
    .my-brokerage{
      width: 49.8%;
      text-align: center;
      display: flex;
      flex-direction: column;
      .p1{
        font-family: PingFang-SC-Medium;
        color: #333333;
        font-size: .28rem;
        font-weight: 600;
        margin-top: .38rem;
      }
      .p2{
        font-family: SFUIText-Regular;
        color: #333333;
        font-size: .6rem;
        line-height: .6rem;
        margin-top: .1rem;
      }
      .xiangqing{
        background-image: url(../../assets/images/my-img/xqbj.png);
        height: 0.55rem;
        line-height: 0.6rem;
        border-radius: 0.08rem;
        width: 1.8rem;
        margin-top: 0.3rem;
        margin-left: 1rem;
      }
    }
    .my-integral{
      width: 49.8%;
      text-align: center;
      display: flex;
      flex-direction: column;
      .p1{
        font-family: PingFang-SC-Medium;
        color: #333333;
        font-size: .28rem;
        font-weight: 600;
        margin-top: .38rem;
      }
      .p2{
        font-family: SFUIText-Regular;
        color: #333333;
        font-size: .6rem;
        line-height: .6rem;
        margin-top: .1rem;
      }
      .xiangqing{
        background-image: url(../../assets/images/my-img/xqbj.png);
        height: 0.55rem;
        line-height: 0.6rem;
        border-radius: 0.08rem;
        width: 1.8rem;
        margin-top: 0.3rem;
        margin-left: 1rem;
        color: #333;
      }
    }
    .color{
      width: 0.4%;
      height: .86rem;
      background: #E4E4E4;
      margin-top: .58rem;
    }
  }
</style>